import script from "./factory.vue?vue&type=script&setup=true&lang=js"
export * from "./factory.vue?vue&type=script&setup=true&lang=js"

import "./factory.vue?vue&type=style&index=0&id=6f5f4b22&lang=css"

const __exports__ = script;

export default __exports__